var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUExp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 40,
    viewBox: "0 0 93 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_59_3041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 18C4 9.16344 11.1634 2 20 2H73C81.8366 2 89 9.16344 89 18C89 26.8366 81.8366 34 73 34H20C11.1634 34 4 26.8366 4 18Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.595 22.949V11.301H43.568V22.949H44.595ZM42.242 11.574H41.228V15.903H39.447V16.787H41.228V22.351H42.242V11.574ZM38.082 14.889V14.33H40.24V13.446H38.095V11.717H37.068V13.446H34.91V14.33H37.068V14.889C37.068 16.8 36.171 18.841 34.598 19.777L35.222 20.57C36.366 19.881 37.185 18.62 37.588 17.099C38.017 18.503 38.836 19.686 39.98 20.323L40.591 19.517C39.018 18.685 38.082 16.748 38.082 14.889ZM45.661 13.381H52.421V12.523H49.574V11.184H48.508V12.523H45.661V13.381ZM55.255 18.36V11.314H54.176V14.85H52.239V15.721H54.176V18.36H55.255ZM51.732 16.059C51.732 14.811 50.601 13.979 49.041 13.979C47.455 13.979 46.337 14.811 46.337 16.059C46.337 17.307 47.455 18.126 49.041 18.126C50.601 18.126 51.732 17.307 51.732 16.059ZM47.351 16.059C47.351 15.279 48.053 14.785 49.041 14.785C50.029 14.785 50.731 15.279 50.731 16.059C50.731 16.839 50.029 17.333 49.041 17.333C48.053 17.333 47.351 16.839 47.351 16.059ZM55.255 18.984H47.676V22.806H55.255V18.984ZM54.215 21.948H48.716V19.829H54.215V21.948ZM66.149 22.988V11.301H65.083V22.988H66.149ZM60.741 14.408V12.315H59.688V14.408C59.688 16.644 58.258 18.841 56.555 19.673L57.205 20.544C58.57 19.816 59.688 18.412 60.221 16.631C60.78 18.308 61.872 19.66 63.224 20.323L63.861 19.465C62.145 18.698 60.741 16.54 60.741 14.408ZM73.559 14.291H76.094V17.333H77.173V11.314H76.094V13.42H73.559V14.291ZM73.832 17.086L74.378 16.254C72.701 15.695 71.518 14.291 71.518 12.757V11.678H70.465V12.757C70.465 14.434 69.308 15.929 67.553 16.514L68.112 17.359C69.477 16.852 70.517 15.838 71.024 14.525C71.531 15.721 72.532 16.631 73.832 17.086ZM77.615 22.806V21.961H70.738V20.713H77.173V17.918H69.659V18.763H76.12V19.907H69.685V22.806H77.615Z",
    fill: "#282D4B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8334 23.8333L14.8334 17.5H17.5V13.5L26.5 13.5V17.5H29.1667V23.8333H23.5V22C23.5 21.1716 22.8285 20.5 22 20.5C21.1716 20.5 20.5 21.1716 20.5 22V23.8333H14.8334ZM15.8334 22.8333H19.5V22C19.5 20.6193 20.6193 19.5 22 19.5C23.3808 19.5 24.5 20.6193 24.5 22V22.8333H28.1667V18.5H25.5L25.5 14.5L18.5 14.5V18.5H15.8334V22.8333Z",
    fill: "#282D4B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1667 16L29.1667 17.5L28.1667 17.5V16H29.1667Z",
    fill: "#282D4B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8334 16L15.8334 17.5H14.8334L14.8334 16H15.8334Z",
    fill: "#282D4B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1667 16V18H20.1667V16H21.1667Z",
    fill: "#282D4B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1667 12V13.5H20.1667V12L21.1667 12Z",
    fill: "#282D4B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8334 16V18H22.8334V16H23.8334Z",
    fill: "#282D4B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8334 12V13.5H22.8334V12L23.8334 12Z",
    fill: "#282D4B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5 12V13.5L25.5 13.5V12L26.5 12Z",
    fill: "#282D4B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 12V13.5L17.5 13.5L17.5 12L18.5 12Z",
    fill: "#282D4B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_59_3041",
    x: 0,
    y: 0,
    width: 93,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_59_3041"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_59_3041",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUExp);
export default __webpack_public_path__ + "static/media/u_exp.49944f424d69f2ed6ed577c1fc55ea23.svg";
export { ForwardRef as ReactComponent };